import { render, staticRenderFns } from "./newones.vue?vue&type=template&id=9ddb7c76"
import script from "./newones.vue?vue&type=script&lang=js"
export * from "./newones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports